import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';

import { restoreStackup, restoreCalculations } from '../../../actions';
import { getStackup } from '../../../reducers'
import ImportingDialog from './ImportingDialog';

export const Container = props => (
  <ImportingDialog {...props} />
);

const mapDispatchToProps = { restoreStackup, restoreCalculations };

const mapStateToProps = (state) => {
  const stackup = getStackup(state);
  return { stackup };
}


export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Container);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/ImportingDialog/ImportingDialogContainer.jsx